import React, { useState, useEffect} from "react";
import { Header, Sidebar } from "../../Layout";
import { Link } from 'react-router-dom'
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import DataTablesProject from "./DataTablesProject";
import { 
    // getProjectList, getProjectStatusList, 
    getProjectFilter} from "../../../actions/projectActions";
// import { getPartners } from "../../../actions/partnerActions";
// import { clientBudgetOverview } from "../../../actions/userDashboardAction";
// import ScheduleTableList from './ScheduleTableList'
import BudgetTableList from "./BudgetTableList";
import DatePicker from "react-datepicker";

const BudgetOverview = (props) => {

    const dispatch = useDispatch();

    const [startDate, setStartDate] = useState(new Date());
    // const [endDate, setEndDate] = useState(new Date());
    const { projects } = useSelector(state=> state.projectStore);

    const [inputProjectData, setProjectData] = useState()
    const [searchInput, setSearchInput] = useState("")
    const [partner, setPartner] = useState("")
    const [dueDate, setDueDate] = useState("")
    const [status, setStatus] = useState("")

    useEffect(() => {
        dispatch(getProjectFilter(searchInput, partner, dueDate, status))
    }, [dispatch, searchInput, partner, dueDate, status])

    useEffect(() => {
        setProjectData(projects)
    }, [projects])

    const handleChange = e => {
        if (e.target.name === 'searchInput') {
            setSearchInput(e.target.value)
        // } else if (e.target.name === 'partner') {
        //     setPartner(e.target.value)
        } else if (e.target.name === 'due_date') {
            setDueDate(e.target.value)
        // } else if (e.target.name === 'status') {
        //     setStatus(e.target.value)
        } else {
            setSearchInput('');
            setPartner('');
            setDueDate('');
            setStatus('');
            setStartDate(new Date());
        }
    }

    const onSelectDate = (date) => {
        setDueDate(moment(date).format('YYYY-MM-DD'))
        setStartDate(date)
    }
    return (
        <>
            <Header />
            <Sidebar />
            <div id="main-content">
                <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-md-6 col-sm-12">
                            <h2>Budget Overview</h2>
                        </div>
                        <div className="col-md-6 col-sm-12 text-right">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/"><i className="icon-home"></i></Link></li>
                                <li className="breadcrumb-item active">Budget Overview</li>
                                <li className="breadcrumb-item active">Budget Overview</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row clearfix py-3">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                                <h3 className="text-bold"><strong>[ Client Name ] Overview</strong></h3>
                        </div>
                    </div>
                    <div className="row clearfix">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="card card-radius">
                                <div className="header card-header custum-bg-warning rounded">
                                    <h2 className="text-white">Budget Overview</h2>
                                </div>
                                <div className="body card-body-shadow">
                                    <div className="progress mt-4">
                                        <div className="progress-bar custum-bg-warning rounded" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style={{"width": "46%"}}>
                                            <span className="sr-only">60% Complete (warning)</span>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <div className="card timeline-card">
                                            <div className="card-body">
                                                <h6 className="card-title text-center"><strong>Total</strong></h6>
                                                <h4 className="card-text text-center"><strong>$1,000,00</strong></h4>
                                            </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="card timeline-card">
                                            <div className="card-body">
                                                <h6 className="card-title text-center"><strong>Spent</strong></h6>
                                                <h4 className="card-text text-center"><strong>$600,000</strong></h4>
                                            </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="card timeline-card">
                                            <div className="card-body">
                                                <h6 className="card-title text-center"><strong>Available</strong></h6>
                                                <h4 className="card-text text-center"><strong>$400,000</strong></h4>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* ------Table------- */}
                                    <div className="table-responsive">
                                        <BudgetTableList />
                                    </div>
                                </div> 
                            </div>
                        </div>
                    </div>
                    <div className="row clearfix">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="card card-radius">
                                <div className="header card-header custum-bg-warning rounded">
                                    <h2 className="text-white">Activity Schedule</h2>
                                    <Link to='/activity-schedule' className="dropdown dropdown-animated scale-left text-white"><i className="fa fa-list fa-lg mr-2"></i>View Full Schedule</Link>
                                </div>
                                <div className="body card-body-shadow">
                                   
                                    <div className="row mt-4">
                                        <div className="col-sm-4">
                                            <div className="form-group relative_pos">
                                                <input 
                                                value={searchInput}
                                                onChange={handleChange}
                                                className="form-control height_38 border_color_orange" 
                                                type={'text'}
                                                name={'searchInput'}
                                                placeholder={'Search....'} />
                                                <span className="searchInput"><i className="icon-magnifier color-orange"></i></span>
                                            </div>
                                        </div>
                                        <div className="col-sm-2 p-0">
                                            <div className="form-group relative_pos ">
                                                <DatePicker
                                                    selected={startDate}
                                                    onChange={(date) => onSelectDate(date)}
                                                    name="due_date"
                                                    id="due_date"
                                                    className="form-control height_38 border_color_orange " />
                                                <span className="searchInput"><i className="fa fa-calendar-o color-orange"></i></span>


                                            </div>
                                        </div>
                                        <div className="col-sm-4"></div>
                                        <div className="col-sm-2">
                                            <div className="form-group">
                                                <select className="form-control height_38 border_color_orange" name={'search'}>
                                                    <option>Select</option>
                                                    <option>Option</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    {/* ------Table------- */}
                                    <div className="">
                                        {/* <ScheduleTableList /> */}
                                        <DataTablesProject data={inputProjectData} />
                                    </div>
                                </div> 
                            </div>
                        </div>
                    </div>
                </div>
            </div> 

        </>
    )

}

export default BudgetOverview;